import { authRoutes } from '@/features/auth/auth-routes';
import { homeRoutes } from '@/features/home/home-routes';
import { todosRoutes } from '@/features/todos/todos-routes';

export const routes = [...authRoutes, ...homeRoutes, ...todosRoutes];
